import React, { FC } from "react";

import NewsLetterSuccessSubscription from "./NewsLetterSuccessSubscription";
import NewsLetterSubscriptionForm, {
  INewsLetterFormBody,
  INewsLetterLinks,
} from "./NewsLetterSubscriptionForm";

export interface INewsLetter {
  /** Privacy and term document links */
  links?: INewsLetterLinks;
  /** Head title */
  joinTitle?: string;
  /** Head description */
  joinDescription?: string;
  /** Success page tile */
  successTitle?: string;
  /** Success page description */
  successDescription?: string;
  /** Success page image */
  successImageSrc?: string;
  /** Boolean for show success page */
  hasSubscription?: boolean;
  /** Submit callback */
  onSubscribe?(body: INewsLetterFormBody): void;
}

const NewsLetter: FC<INewsLetter> = ({
  links,
  joinTitle,
  joinDescription,
  successTitle,
  successDescription,
  successImageSrc,
  onSubscribe,
  hasSubscription = false,
}) =>
  hasSubscription ? (
    <NewsLetterSuccessSubscription
      successTitle={successTitle}
      successDescription={successDescription}
      successImageSrc={successImageSrc}
    />
  ) : (
    <NewsLetterSubscriptionForm
      links={links}
      joinTitle={joinTitle}
      joinDescription={joinDescription}
      onSubmitForm={onSubscribe}
    />
  );

export default NewsLetter;
